import React, { useCallback, useState } from 'react';
import { useIsClientsDrawer } from '../context/InteractionsContext';
import { StructuredInteractionsForm } from './form/StructuredInteractionsForm';
import { StructuredInteractionsHeader } from './StructuredInteractionsHeader';
import { StructuredInteractionsList } from './StructuredInteractionsList';

export function InteractionsContent() {
  const isClientsDrawer = useIsClientsDrawer();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const interactions = []; // placeholder for PAYS-11326

  const openForm = useCallback(() => setIsFormOpen(true), []);
  const closeForm = useCallback(() => setIsFormOpen(false), []);

  return (
    <div
      className={`structured-interactions panel-wrapper ${isClientsDrawer ? 'mb-4' : 'mb-6'}`}
      data-test-element="structured-interactions"
    >
      <StructuredInteractionsHeader
        disabled={isFormOpen}
        labelText="Add Interaction"
        onClick={openForm}
        title="Interactions"
      />
      {isFormOpen && (
        <StructuredInteractionsForm onClose={closeForm} />
      )}
      <StructuredInteractionsList interactions={interactions} />
    </div>
  );
}
